import { SVGProps } from 'react';

const LightThemeIcon = (props: SVGProps<SVGSVGElement>) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  (<svg
    width={12}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="LightThemeIcon">
    <g
      clipPath="url(#a)"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5.647 8.565a2.353 2.353 0 1 0 0-4.706 2.353 2.353 0 0 0 0 4.706ZM5.647 1.035v.941M5.647 10.447v.941M1.986 2.55l.668.669M8.64 9.205l.668.668M.47 6.212h.942M9.882 6.212h.941M1.986 9.873l.668-.668M8.64 3.219l.668-.668" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="none" d="M0 0h12v12H0z" />
      </clipPath>
    </defs>
  </svg>)
);

export default LightThemeIcon;
